import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useActiveChannelStore = defineStore('active-channel', () => {
  const activeChannelId = ref<string | null>(null)

  function setChannelId(id: string) {
    activeChannelId.value = id
  }

  function clearChannel() {
    activeChannelId.value = null
  }

  return { activeChannelId, setChannelId, clearChannel }
})
